const cookieName = 'accInfo';
const cookieSecurityAttrs = window.location.protocol === 'https:' ? ';SameSite=None;Secure' : '';

const authCookie = () => {
  let acc;
  const value = document.cookie;
  const parts = value.split(cookieName + '=');
  if (parts.length > 1) {
    if (parts[0].includes('users_id') || parts[1].includes('users_id')) {
      acc = JSON.parse(parts.pop().split(';').shift());
      return acc;
    } else {
      return null;
    }
  } else {
    return null;
  }
};

const logoutCookie = () => {
  const accInfoValue = '';
  const myDate = new Date();
  myDate.setMonth(myDate.getMonth() + 12);
  document.cookie = `${cookieName}=${accInfoValue};expires=${myDate};domain=${process.env.REACT_APP_HYBRID_SUBDOMAIN};path=/${cookieSecurityAttrs}`;
};

const loginCookie = cookieValue => {
  const accInfoValue = JSON.stringify(cookieValue);
  const myDate = new Date();
  myDate.setMonth(myDate.getMonth() + 12);
  document.cookie = `${cookieName}=${accInfoValue};expires=${myDate};domain=${process.env.REACT_APP_HYBRID_SUBDOMAIN};path=/${cookieSecurityAttrs}`;
};

export { authCookie, loginCookie, logoutCookie };
